import z from "zod";

export const protocolSendSchema = z.object({
	/** Also mail the protocol to the person triggering the send. */
	sendCopyToCreator: z.boolean().default(false),
	/** Render the protocol as a PDF and attach it to every mail. */
	withAttachment: z.boolean().default(true),
});

export type ProtocolSendFormSchema = z.infer<typeof protocolSendSchema>;
